import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	cardData: [
		{
			id: "",
			code: "",
			name: "",
			startDate: "",
			startDateStr: "",
			endDate: "",
			endDateStr: "",
			duration: 0,
			durationSpan: "",
		},
	],
};

const cardRunningCoursesSlice = createSlice({
	name: "cardRunningCourses",
	initialState: initialState,
	reducers: {
		updateCard(state, action) {
			// console.log("update cardRunningCourses");
			// console.log(action);

			state.cardData = action.payload;
		},
	},
});

export const cardRunningCoursesActions = cardRunningCoursesSlice.actions;

export default cardRunningCoursesSlice;
